import React from "react";

function reloadToDashboardIndex() {
  window.location.assign("/dashboard?view=table");
}

export default function AppErrorFallback() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        padding: "48px 16px",
      }}
    >
      <div
        role="alert"
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: 16,
          border: "1px solid rgba(226,232,240,0.8)",
          padding: 32,
          boxShadow: "0 20px 40px rgba(148,163,184,0.25)",
        }}
      >
        {/* Icon */}
        <div
          style={{
            margin: "0 auto 20px",
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: "#fffbeb",
            border: "1px solid #fef3c7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width={28}
            height={28}
            fill="none"
            viewBox="0 0 24 24"
            stroke="#d97706"
            strokeWidth={1.75}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
            />
          </svg>
        </div>

        <h1
          style={{
            textAlign: "center",
            fontSize: 20,
            fontWeight: 600,
            color: "#0f172a",
            margin: "0 0 8px",
          }}
        >
          Something went wrong
        </h1>
        <p
          style={{
            textAlign: "center",
            fontSize: 14,
            lineHeight: 1.6,
            color: "#475569",
            margin: "0 0 32px",
          }}
        >
          The application hit an unexpected error. Returning to the dashboard
          with a fresh load often resolves this after a recent update.
        </p>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            type="button"
            onClick={reloadToDashboardIndex}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "12px 20px",
              borderRadius: 12,
              background: "#0f172a",
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              border: "none",
              cursor: "pointer",
              boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
              transition: "background 0.15s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#1e293b")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#0f172a")}
          >
            Move to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
